import { produce } from 'immer';
import {
  NOTIFICATIONCENTER_UPDATE,
  NOTIFICATIONCENTER_TEMPLATECOPIED,
  NOTIFICATIONCENTER_DELETE,
  NOTIFICATION_DELETE_MODAL_OPEN,
  NOTIFICATIONCENTER_OPEN,
  NOTIFICATIONCENTER_LOADING,
  NOTIFICATIONCENTER_PDSNOTIFICATIONCOMPLETED
} from './actions';
import { NotificationsAction, NotificationsState } from './notifications-types';
import { deleteNotifications, updateNotifications } from './updater';

const initialNotificationState: NotificationsState = {
  notificationDataList: [],
  deleteModalOpen: false,
  notificationCenterOpen: false,
  isLoading: false,
  hasCompletedPdsNotification: false
};

export function notificationsReducer(baseState: NotificationsState = initialNotificationState, action: NotificationsAction) {
  const { type, payload } = action;
  return produce(baseState, (state: NotificationsState) => {
    switch (type) {
      case NOTIFICATIONCENTER_UPDATE:
        return updateNotifications(state, payload);
      case NOTIFICATIONCENTER_DELETE:
        return deleteNotifications(state, payload);
      case NOTIFICATIONCENTER_TEMPLATECOPIED:
        state.hasCopiedTemplate = true;
        return state;
      case NOTIFICATIONCENTER_PDSNOTIFICATIONCOMPLETED:
        state.hasCompletedPdsNotification = payload?.hasCompletedPdsNotification;
        return state;
      case NOTIFICATIONCENTER_OPEN:
        state.notificationCenterOpen = payload?.notificationCenterOpen;
        return state;
      case NOTIFICATION_DELETE_MODAL_OPEN:
        state.deleteModalOpen = payload?.deleteModalOpen;
      case NOTIFICATIONCENTER_LOADING:
        state.isLoading = payload?.isLoading;
        return state;
      default:
        return state;
    }
  });
}
